import Slider, { DEFAULT_OPTIONS } from 'CoreComponents/slider';

document.querySelectorAll(DEFAULT_OPTIONS['selector']['slider']).forEach(slider => {
  new Slider(slider);
});
